import { EType, IMediaSchema } from 'shared/repositories/search-engine/entities/media/MediaSchema';

export const prepareImageUrl = (media: IMediaSchema[]): string | null => {
  const image = media.find(({ type }) => type !== EType.Video);

  if (!image) {
    return null;
  }

  return image.previewUrl;
};
